export default {
  message: {
    "error": "Ой! Щось пішло не так.",
    "Sorrysomeerrorsoccurred": "Виникла непередбачувана помилка. Ви можете спробувати змінити мову або вийти та перезапустити додаток.",
    "quit": "Вийти",
    "language": "Мова",
    "Youcanchangethelanguagehere": "Ви можете змінити мову тут!",
    "current": "Поточна",
    "home": "Головна",
    "friends": "Друзі",
    "wallet": "Гаманець",
    "aboutus": "Про нас",
    "Sharewithfriends": "Поділитися з друзями",
    "copyFailure": "Помилка копіювання",
    "copySuccess": "Успішне копіювання",
    "Claimreward": "Отримати винагороду",
    "DailyLogin": "Щоденний вхід",
    "noInvitationsYet": "Ще немає запрошень",
    "LoadMore": "Завантажити більше",
    "WatchAD": "Подивитися рекламу",
    "continue": "Продовжити",
    "Congratulations": "Вітаємо",
    "MyFriends": "Мої друзі",
    "Invitefriends": "Запросити друзів",
    "Invitepremiumfriends": "Запросити преміум-друзів",
    "DailyTasks": "Щоденні завдання",
    "inviteDesc": "+{num} ${name} за кожного запрошеного друга",
    "DailyTasksDesc": "Виконайте завдання, щоб отримати більше airdrop",
    "SponsorsandPartners": "Спонсори та партнери",
    "Receivingwallet": "Гаманець для отримання",
    "Enterwalletaddress": "Введіть адресу гаманця {name}",
    "Claim": "Отримати",
    "Booster": "Бустер",
    "RentPeriod": "Період оренди",
    "days30": "30 днів",
    "Dailyprofit": "Щоденний прибуток",
    "Totalprofit": "Загальний прибуток",
    "Quantity": "Кількість",
    "RentPrice": "Ціна оренди",
    "RentMiner": "Орендувати майнера",
    "Insufficient": "Недостатньо запрошених",
    "InsufficientMsg": "Вам потрібно запросити {num} друзів, щоб заробити більше аксесуарів.",
    "Settings": "Налаштування",
    "copyid": "Копіювати ID",
    "UpgradeSuccessfully": "Оновлення успішно",
    "Name": "Ім'я",
    "userinfo": "Інформація про користувача",
    "disconnect": "Відключитися",
    "Startmining": "Розпочати видобуток",
    "Welcome": "Ласкаво просимо до {name}",
    "Withdrawal": "Виведення",
    "Minimumamount": "Мінімальна сума",
    "Networkfee": "Комісія мережі",
    "Enteramount": "Введіть суму",
    "Submit": "Надіслати",
    "MinimumTip": "Сума виведення занадто мала. Мінімальна сума виведення: {num}",
    "MaximumTip": "Недостатня сума, максимальна сума, яку ви можете вивести: {num}",
    "SubmittedTip": "Надіслано, очікуйте обробки протягом 30-60 робочих днів",
    "WithdrawStatus": "Статус",
    "Submissiontime": "Час подання",
    "WithdrawAwaitTip": "* Передбачається, що це займе 30-60 робочих днів. Запрошення більше друзів може прискорити процес перевірки.",
    "Processing": "Обробка",
    "Amount": "Сума",
    "Numberoffriends": "Кількість друзів: {now}/{limit}",
    "InviteTip": "Щоб зробити перше виведення, вам потрібно запросити {limit} друзів приєднатися до майнінгового додатку.",
    "openonphone": "Відкрийте це посилання на своєму телефоні.",
    "claimTip": "Сума для отримання занадто мала. Мінімальна сума для отримання: {num}",
    "WalletBalance": "Баланс гаманця",
    "Withdraw": "Вивести",
    "SetWalletAddress": "Встановити адресу гаманця",
    "WithdrawalRecord": "Записи виведення",
    "Norecords": "Немає записів",
    "Whatis": "Що таке {name}?",
    "All": "Всі",
    "save": "Зберегти",
    "successWithdrawal": "Успішне сканування {num}",
    "secondsago": "{time} секунд тому",
    "Loading": "Завантаження...",
    "PaymentConfirming": "Перевірка статусу транзакції...",
    "Check": "Перевірити",
    "CheckFail": "Транзакцію не завершено. Будь ласка, перевірте знову через 5 секунд.",
    "Addname": "Додати '{name}' до свого імені",
    "Restattcheck": "Перезапустіть додаток, щоб перевірити",
    "Copyname": "Скопіювати '{name}'",
    "SubmissionFailed": "Подання не вдалося, будь ласка, спробуйте ще раз пізніше",
    "WithdrawalReview": "Перевірка виведення",
    "WebWithdrawAwaitTip": "* Передбачається, що це займе 24-48 годин. Запрошення більше друзів може прискорити процес перевірки.",
    "Success": "Успішно",
    "Rejection": "Відхилено",
    "WebSubmittedTip": "Надіслано, ми обробимо це якнайшвидше.",
    "select_payment_method": "Виберіть спосіб оплати",
    "total_amount": "Загальна сума",
    "next_step": "Наступний крок",
    "creating_order": "Створення замовлення...",
    "order_created": "Замовлення створено",
    "order_status": "Статус замовлення",
    "order_id": "Ідентифікатор замовлення",
    "order_amount": "Сума замовлення",
    "order_status_desc": "Опис статусу замовлення",
    "payment_cancelled": "Оплату скасовано",
    "opening_payment": "Відкриття оплати...",
    "payment_success": "Оплата пройшла успішно",
    "payment_failed": "Платіж не вдалося виконати",
    "payment_pending": "Платіж в обробці",
    "payment_processing": "Обробка платежу",
    "create_order_failed": "Не вдалося створити замовлення",
    "creating_ton_order": "Створення замовлення TON...",
    "check_payment_status": "Перевірка статусу платежу...",
    "use_ton_payment": "Використати платіж TON",
    "connect_wallet": "Підключити гаманець",
    "start_transaction": "Розпочати транзакцію",
    "address": "Адреса",
    "amount_ton": "Сума TON",
    "copy": "Скопіювати",
    "comment_memo": "Коментар",
    "comment_memo_desc": "Будь ласка, введіть коментар",
    "comment_memo_placeholder": "Введіть коментар",
    "amount": "Сума",
    "wallet_address": "Адреса гаманця",
    "you_can_choose_to_connect_wallet_to_pay": "Ви можете вибрати підключення гаманця для оплати",
    "or_manually_transfer_to_the_above_address": "Або вручну переказати на вказану адресу (зверніть увагу, що сума та коментар повинні бути точно такими ж)",
    "transaction_success": "Транзакція успішна",
    "transaction_failed": "Транзакція не вдалася",
    "transaction_error": "Помилка транзакції",
    "transaction_status": "Статус транзакції",
    "transaction_id": "ID транзакції",
    "transaction_amount": "Сума транзакції",
    "transaction_status_desc": "Опис статусу транзакції",
    "miner_detail": "Деталі майнера",
    "rent_period": "Період оренди",
    "days": "{days} днів",
    "daily_yield": "Щоденний дохід",
    "total_yield": "Загальний дохід",
    "invite_friends": "Запросити друзів",
    "price": "Ціна",
    "rent": "Оренда",
    "free_claim": "Безкоштовна отримання виграшу",
    "redeem": "Виплатити",
    "buy": "Оренда",
    "invite_friends_not_enough": "Недостатньо запрошень друзів",
    "redeem_success": "Виплата успішна",
    "redeem_failed": "Виплата не вдалася",
    "rent_success": "Оренда успішна",
    "rent_failed": "Оренда не вдалася",
    "TotalPower": "Загальна потужність",
    "MaxQuantity": "Максимальна вартість досягнута",
    "Running": "Виконується",
    "Stop": "Зупинити",
    "Withdrawalunlock": "Розблокування виводу",
    "Close": "Закрити",
    "Delivering": "Доставляється",
    "Duetothelargenumber": "Враховуючи велику кількість отримувачів, ваш аірдроп очікується через 15-20 робочих днів",
    "WithdrawalunlockTip": "Вам потрібно {num} запрошених друзів, щоб виконати завдання/прив'язати гаманці для розблокування виводу",
    "mining_title": "Робот",
    "Upgrade": "Оновити",
    "partner": "Партнер",
    "faq": "Часті запитання",
    "task": "Завдання",
    "OpenRobot": "Відкрити робота",
    "MyRobot": "Мій робот",
    "Level": "Рівень",
    "Commission": "Комісія",
    "DirectFriends": "Прямі друзі",
    "Feedback": "Відгук",
    "Pleaseenteryouremailaddress": "Будь ласка, введіть вашу електронну адресу",
    "Inputfeedbackcontent": "Введіть зміст відгуку",
    "Submitfeedback": "Надіслати відгук",
    "Feedbacksubmittedsuccessfully,thankyouforyourvaluablefeedback": "Відгук надіслано успішно, дякуємо за ваш цінний відгук",
    "Feedbacksubmissionfailed,pleaseretriy": "Надсилання відгуку не вдалося, будь ласка, спробуйте ще раз",
    "Addressformaterror": "Помилка формату адреси",
    "Readclipboardfailed": "Не вдалося прочитати буфер обміну",
    "Youhavealreadyfeedbackedtoday,pleasecomebacktomorrow": "Ви вже залишали відгук сьогодні, будь ласка, поверніться завтра",
    "Record": "Запис",
    "Newuserguidance": "Переглянути Тур вітання",
    "Usetonwallet": "Використовуйте гаманець TON",
    "Reward": "Нагорода",
    "Connectwallet": "Підключити гаманець",
    "Notconnected": "Не підключено",
    "Disconnect": "Відключити",
    "AboutTAI": "Деталі токена",
    "WithdrawalRecordDesc": "Запис про виведення",
    "StartAItrading": "Почати торгівлю AI",
    "Next": "Далі",
    "Start": "Почати",
    "WithdrawalSuccess": "Виведення успішне",
    "WithdrawalFail": "Виведення не вдалося",
    "Max": "Макс",
    "WithdrawalRecords": "Записи про виведення",
    "Commissionrules": "Правила комісії",
    "Mycommission": "Моя комісія",
    "Shop": "Магазин",
    "BuyDifferentAIrobots": "Оновіть за допомогою обчислювальних пристроїв для швидших сканувань!",
    "CurrentRunningAIrobots": "Поточні AI роботи",
    "DailyProfit": "Щоденний прибуток",
    "Buy": "Купити",
    "ValidityPeriod": "Термін дії",
    "Days": "Дні",
    "Price": "Ціна",
    "APY": "APY",
    "NoRobot": "Немає обчислювальної потужності",
    "RemainingTime": "Залишковий час",
    "InviteandEarn": "Запросити та заробити",
    "InvitDec": "Запросіть ваших друзів приєднатися до AI трейдингу та заробляти комісії USDT і токени airdrop разом!",
    "ShareToGroups": "Поділитися з групами",
    "Select_payment_method": "Виберіть спосіб оплати",
    "twa_pay_tip_with_memo": "Будь ласка, переконайтеся, що адреса, сума та примітка узгоджені для переказу.",
    "twa_pay_tip": "Будь ласка, переконайтеся, що адреса та сума правильні для переказу.",
    "twa_pay_tip_placeholder": "Введіть коментар",
    "twa_pay_tip_placeholder_with_memo": "Введіть коментар з приміткою",
    "twa_pay_tip_placeholder_without_memo": "Введіть коментар без примітки",
    "twa_pay_tip_placeholder_with_memo_placeholder": "Введіть коментар з приміткою",
    "twa_pay_tip_placeholder_without_memo_placeholder": "Введіть коментар без примітки",
    "realtime_ai": "Торгівля на базі ШІ в реальному часі",
    "check_transaction_status": "Перевірити статус транзакції",
    "transaction_wait": "Транзакція обробляється. Ви можете вийти з додатку. Повідомлення сповістить вас, коли це завершиться.",
    "Pleaseenteravalidemailaddress": "Будь ласка, введіть дійсну адресу електронної пошти",
    "max_robot_tip": "Досягнуто обмеження на покупку — спробуйте інший план, щоб продовжити торгівлю!",
    "connectFailure": "Не вдалося підключити гаманець",
    "connectSuccess": "Гаманець підключено успішно",
    "PayNow": "Сплатити зараз",
    "min_withdrawal_amount": "Мінімальна сума виведення становить {num} {coin_name}",
    "max_withdrawal_amount": "Максимальна сума виведення становить {num} {coin_name}",
    "balance_not_enough": "У вас недостатньо коштів для цього виведення.",
    "Numberofgroups": "Кількість груп: {now}/{limit}",
    "Withdraw_success": "Виведення успішне",
    "allProfit": "Загальний прибуток",
    "AnnualProfit": "Річний прибуток",
    "ScanWallet": "Сканувати гаманець",
    "wallet_check": "перевірка_гаманця",
    "Found": "Знайдено",
    "ScanSpeed": "Швидкість сканування",
    "MyComputingPower": "Обчислення",
    "Scanning": "Сканування!",
    "WithdrawDetail": "Деталі виведення",
    "ScanSuccess": "Ваша успішність сканування зросла!",
    "TaskDescription": "Завершуйте завдання, щоб підвищити свій успіх сканування!",
    "InitializingMiningSystem": "Ініціалізація системи сканування...",
    "NoWithdrawalRecord": "Немає запису про виведення",
    "Invite": "Необхідні запрошення",
    "Free": "Безкоштовно",
    "Confirm": "Підтвердити",
    "RefreshTasks": "Оновити завдання",
    "NumberofGroups": "Кількість груп: {now}/{limit}",
    "SendMessage": "Відправити повідомлення",
    "NumberofShares": "Кількість акцій: {now}/{limit}",
    "NumberofTasks": "Кількість завдань: {now}/{limit}",
    "CompleteTask": "Виконати завдання",
    "Accelerated": "Прискорене",
    "Accelerated_withdrawals_success": "Прискорені виведення успішно",
    "GoBuy": "Йдіть купити",
    "SpeedUpScan": "Прискорити",
    "Earnings": "Доходи",
    "learnMore": "Дізнатися більше",
    "claimSuccess": "Винагороду отримано успішно",
    "claimFailed": "Винагороду не вдалося отримати, будь ласка, спробуйте ще раз",
    "noDividends": "Немає дивідендів для отримання",
    "dividendsInfoFallback": "Запросіть друзів, щоб заробити реферальні винагороди"
}};